import welcomePageDictionary_2 from '@pages/welcome_2/i18n/welcome_2.dic.json';

export const welcomePage_2 = {
  WELCOME_PAGE_2: welcomePageDictionary_2,
};

export const welcomePageNamespaces_2 = Object.keys(welcomePage_2);
